export default __webpack_public_path__ + "static/media/btn_close_white.20f10373.svg";